import { createSelector } from "reselect"
import { initialState } from "./reducer"

/**
 * Direct selector to the leadersImport state domain
 */

const selectLeadersImportDomain = (state) =>
  state.get("leadersImport", initialState)

/**
 * Other specific selectors
 */

export const makeSelectIsDownloading = () =>
  createSelector(selectLeadersImportDomain, (state) =>
    state.get("isDownloading")
  )

export const makeSelectIsUploading = () =>
  createSelector(selectLeadersImportDomain, (state) => state.get("isUploading"))
/**
 * Default selector used by LeadersImport
 */

const makeSelectLeadersImport = () =>
  createSelector(selectLeadersImportDomain, (substate) => substate.toJS())

export default makeSelectLeadersImport
export { selectLeadersImportDomain }
